module.exports = __webpack_public_path__ + "media/newstyle/images/icon-rakuten-f4d8b180a471986e43d0b293c8d20da4.svg";